module.exports = __webpack_public_path__ + "static/media/testimonial_empty.ba7a52f5.png";